import { useEffect } from 'react';
import { generatePath, Outlet, useNavigate, useParams } from 'react-router-dom';
import { tr } from '@repo/locale';
import { TestId } from '@repo/test-id';
import { toast } from '@repo/toast';

import { usePriceRulesContext } from '@features/ownedParkingManage/contexts/PriceRulesContext';

import { ROUTE_PATHS } from '@router/paths';
import { RouteName } from '@router/routeNames';

export default function PriceRuleExistsGuard() {
  const { priceRuleId, id: parkingId } = useParams<{ priceRuleId: string; id: string }>();
  const priceRules = usePriceRulesContext();
  const navigate = useNavigate();

  const priceRule = priceRules.find((rule) => rule.id === priceRuleId);

  useEffect(() => {
    if (!priceRule) {
      const testId = TestId.root('priceRuleExistsGuardError');
      toast.danger(tr('owned_parking_manage:manage.pricing.rule.error.not_found'), testId);
      navigate(generatePath(ROUTE_PATHS[RouteName.MY_PARKING_MANAGE_PRICE_RULES], { id: parkingId }), {
        replace: true,
      });
    }
  }, [priceRule, navigate, parkingId]);

  if (!priceRule) {
    return null;
  }

  return <Outlet context={priceRule} />;
}
